import { useLocations, LocationNode } from "@adsk/acc-locations-components";
import { useCallback, useMemo } from "react";

const insertNodeAndChildren = (arr: LocationNode[], node: LocationNode) => {
  arr.push(node);
  (node.children || []).forEach(subNode => insertNodeAndChildren(arr, subNode));
};

export const useFlatLocationsList = (): LocationNode[] => {
  const { treeData } = useLocations();
  return useMemo(() => {
    if (!treeData) {
      return [];
    }

    const result: LocationNode[] = [];
    treeData.forEach(node => insertNodeAndChildren(result, node));
    return result;
  }, [treeData]);
};

export const useIsLocationInTree = () => {
  const locations = useFlatLocationsList();
  return useCallback(
    (locationId: string | undefined | null) => {
      if (!locationId) {
        return false;
      }

      return locations.some(location => location.id === locationId);
    },
    [locations]
  );
};
